/* MM / Bloc CTA produit — assets/mm-product-cta.js
   Rotation de la réassurance : .is-active tourne toutes les 4 s (fondu géré
   en CSS), dots synchronisés, pause au survol et onglet caché, immobile en
   prefers-reduced-motion. Idempotent (garde data-mm-pcta-ready) : les
   previews ré-exécutent les scripts. */
   (function () {
	'use strict';
  
	var DELAY = 4000;
  
	function init(root) {
	  if (root.dataset.mmPctaReady === 'true') return;
	  root.dataset.mmPctaReady = 'true';
  
	  var wrap = root.querySelector('[data-pcta-messages]');
	  if (!wrap) return;
	  var messages = Array.prototype.slice.call(wrap.querySelectorAll('.mm-pcta__message'));
	  if (messages.length < 2) return;
	  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  
	  var dots = Array.prototype.slice.call(root.querySelectorAll('.mm-pcta__mdot'));
	  var index = 0;
	  var paused = false;
  
	  function show(i) {
		index = (i + messages.length) % messages.length;
		messages.forEach(function (m, j) { m.classList.toggle('is-active', j === index); });
		dots.forEach(function (d, j) {
		  d.classList.toggle('is-active', j === index);
		  d.classList.remove('is-cycling');
		});
		/* relance l'anneau de progression du dot actif : reflow forcé pour
		   redémarrer l'animation CSS (même pattern que mm-hero.js) */
		var active = dots[index];
		if (active) {
		  void active.offsetWidth;
		  active.classList.add('is-cycling');
		}
	  }
  
	  /* l'interval s'arrête de lui-même si la racine quitte le DOM (le product
		 form est re-rendu à chaque variante via la Section Rendering API :
		 sans ça, un interval orphelin par re-rendu tournerait à vie) */
	  var timer = window.setInterval(function () {
		if (!root.isConnected) { window.clearInterval(timer); return; }
		if (paused || document.hidden) return;
		show(index + 1);
	  }, DELAY);
  
	  root.addEventListener('mouseenter', function () { paused = true; });
	  root.addEventListener('mouseleave', function () { paused = false; });
	}
  
	function setup(scope) {
	  (scope || document).querySelectorAll('.mm-pcta').forEach(init);
	}
  
	window.MmProductCta = { setup: setup };
  
	if (document.readyState === 'loading') {
	  document.addEventListener('DOMContentLoaded', function () { setup(); });
	} else {
	  setup();
	}

	document.addEventListener('product:product-reload-complete', function () {
	  setup();
	});
  })();